export const AppointmentsRoutes = [
  {
    name: 'appointments',
    path: '/appointments',
    component: () => import('@/pages/appointments/Appointments.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'appointment-details',
    path: '/appointments/:id',
    component: () => import('@/pages/appointments/AppointmentsDetails.vue'),
    meta: {
      requiresAuth: true,
    },
  },
];

export default AppointmentsRoutes;
